import { colors } from '@flowwai-frontend/shared/style-guide'

export const crmItemCreationTheme = {
   light: {
      header: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         borderColor: 'border-gray-300',
         configNameColor: 'text-gray-900'
      },
      modalPipelineSection: {
         pipelineColor: 'text-gray-700',
         salesPipelineTextColor: 'text-gray-500',
         containerBGColor: 'bg-gray-100'
      },
      footer: {
         leftArrowIconFillColor: colors['primary-600'],
         rightArrowIconFillColor: colors['base-white'],
         borderColor: 'border-gray-300'
      },
      createLead: {
         sendNotificationTextColor: 'text-gray-600',
         borderColor: '!border-gray-300'
      },
      addRecord: {
         cardBorderColor: 'border-gray-200',
         titleColor: 'text-gray-700',
         selectedTitleColor: 'text-gray-800',
         selectedCheckIconColor: colors['primary-600'],
         borderHoverColor: 'hover:border-primary-400',
         borderSelectedColor: 'border-primary-600',
         bgSelectedColor: 'bg-primary-50'
      }
   },
   dark: {}
}
